"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultKey = defaultKey;
exports.useUncontrolledProp = useUncontrolledProp;
exports.useUncontrolled = useUncontrolled;
/* eslint-disable prefer-arrow/prefer-arrow-functions */
// forked from https://github.com/jquense/uncontrollable/blob/master/src/index.ts
const react_1 = require("react");
function defaultKey(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function useUncontrolledProp(propValue, defaultValue, handler) {
    const wasPropRef = (0, react_1.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, react_1.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
     * If a prop switches from controlled to Uncontrolled
     * reset its value to the defaultValue
     */
    if (!isProp && wasProp && stateValue !== defaultValue) {
        setState(defaultValue);
    }
    return [
        isProp ? propValue : stateValue,
        (0, react_1.useCallback)((...args) => {
            const [value, ...rest] = args;
            const returnValue = handler?.(value, ...rest);
            setState(value);
            return returnValue;
        }, [handler]),
    ];
}
function useUncontrolled(props, config) {
    return Object.keys(config).reduce((result, fieldName) => {
        const { [defaultKey(fieldName)]: defaultValue, [fieldName]: propsValue, ...rest } = result;
        // @ts-ignore-next-line
        const handlerName = config[fieldName];
        // @ts-ignore-next-line
        const [value, handler] = useUncontrolledProp(propsValue, defaultValue, props[handlerName]);
        return {
            ...rest,
            [fieldName]: value,
            [handlerName]: handler,
        };
    }, props);
}
